import React from 'react';

function BlogCta({ navigateTo }) {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
          Stay Updated with Our Insights
        </h2>
        <p className="mt-4 text-xl text-gray-600">
          Explore our latest articles on AI, IT strategy, and technology trends.
        </p>
        <div className="mt-8">
          <button onClick={() => navigateTo('blog')} className="btn btn-primary text-lg">
            Visit Our Blog
          </button>
        </div>
      </div>
    </section>
  );
}

export default BlogCta; 